import {Table} from "../../tables/BasicTable";
import React, {useContext, useEffect, useState} from "react";
import {useAuth} from "../../../providers/authProvider";
import BoxLayout from "../../../layouts/BoxLayout";
import DefaultButton from "../../buttons/DefaultButton";
import {ApiContext} from "../../contexts/ApiContext";
import {useNavigate, useParams} from "react-router-dom";
import H2Header from "../../headers/h2";
import DefaultLayoutWithoutSideBar from "../../../layouts/DefaultLayoutWithoutSideBar";
// Reusable components (same as company visit page)
import SectionCard from "../../common/SectionCard";
import { InfoGrid, InfoItem } from "../../common/InfoGrid";
import PresentServiceInfo from "../../common/PresentServiceInfo";

function ContactPersonVisitDetailPage() {
    const {Url } = useContext(ApiContext)
    const { token } = useAuth();
    const navigate = useNavigate();
    const [companyVisitDetails, setCompanyVisitDetails] = useState([])
    const [loading, setLoading] = useState(false)
    const [dataAvailable, setDataAvailable] = useState(false)

    // Get ID from URL
    const params = useParams();
    const getColumnsChildern = () => [
        {
            Header: "ID",
            accessor: "ID",
        },
        {
            Header: "Voornaam",
            accessor: "FirstName",
        },
        {
            Header: "Achternaam",
            accessor: "LastName",
        },
        {
            Header: "Leeftijd",
            accessor: "Age",
        },
        {
            Header: "Email Ourder/verzorger",
            accessor: "Email",
        },
        {
            Header: "Naam Ouder/verzorger",
            accessor: "ParentName",
        },

    ];

    const handleDownload = () => {
        fetch(Url + "user/company-visit-export/" + params.id, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.download =  companyVisitDetails.Company + ".xlsx" || "downloaded-file";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching the file:", error);
            });
    };

    useEffect(() => {
        if (token) {
            try{
                setLoading(true)
                fetch(Url + 'user/company-visit-details/' + params.id, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': "Bearer " + token,
                    },
                })
                    .then((res) => {
                        if (res.status === 200) {
                            return res.json()
                        }else{
                            setDataAvailable(false)
                            return {
                                "message": "Geen informatie voor dit bedrijfsbezoek beschikbaar."
                            }
                        }
                    })
                    .then((data) => {
                        if (data && !data.message) {
                            setCompanyVisitDetails(data)
                            setDataAvailable(true)
                        } else {
                            setDataAvailable(false)
                            setCompanyVisitDetails(data)
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                    })
            }catch (error){
                setDataAvailable(false)
                return [{
                    "message": "Laden niet gelukt."
                }]
            }
        }
    }, [token, Url, params.id ]);
    let dataTable
    if (companyVisitDetails.Children){
        dataTable =  (<Table tableData={companyVisitDetails.Children} setRowdata={undefined} onRowClick={() => console.log("click")} getColumns={getColumnsChildern()}></Table>)
    }else {
        dataTable = <div>Er zijn nog geen kinderen ingeschreven voor dit bezoek</div>
    }
    let ownChildrenButton
    if (companyVisitDetails.OwnChildren){
        ownChildrenButton =  (<div>
            Je hebt zelf kinderen aangemeld voor het feest. Klik op de knop bewerken om deze inschrijvingen te wijzigen.
            <DefaultButton content="Bewerk"
                           onClick={() => window.open("/user/visits-overview", "_blank")}></DefaultButton>
        </div>)

    } else{
        ownChildrenButton = (<div>
                Wil je je eigen kinderen ook aanmelden? Klik dan op de knop inschrijven hieronder.
                <DefaultButton content="Inschrijven"
                               onClick={() => window.open("/company/welcome?signup_code=" + companyVisitDetails.SignUpCode, "_blank")}></DefaultButton>
            </div>
        )
    }

    let dataViewer

    if (dataAvailable) {
        let SignUpTarget
        SignUpTarget = window.location.origin + "/company/welcome?signup_code="+companyVisitDetails.SignUpCode
        dataViewer = (
            <BoxLayout>
                <div className="mb-4 mt-4">
                    <DefaultButton content="Terug" onClick={() => navigate("/company/visits-overview/", { replace: false })}></DefaultButton>
                </div>
                <H2Header headerText={companyVisitDetails.Company}/>
                <SectionCard title="Algemeen">
                    <InfoGrid>
                        <InfoItem label="Datum">{companyVisitDetails.Date}</InfoItem>
                        <InfoItem label="Min leeftijd kinderen">{companyVisitDetails.MinChildAge}</InfoItem>
                        <InfoItem label="Max leeftijd kinderen">{companyVisitDetails.MaxChildAge}</InfoItem>
                        <InfoItem label="Starttijd">{companyVisitDetails.StartTime}</InfoItem>
                        <InfoItem label="Eindtijd">{companyVisitDetails.EndTime}</InfoItem>
                        <InfoItem label="Aantal kinderen">{companyVisitDetails.NumberOfChildren}</InfoItem>
                        <InfoItem label="Aantal volwassen">{companyVisitDetails.NumberOfAdults}</InfoItem>
                        <InfoItem label="Totaal aantal inschrijvingen">{companyVisitDetails.NumberOfAdults + companyVisitDetails.NumberOfChildren}</InfoItem>
                        <InfoItem label="Zaalcapaciteit">{companyVisitDetails.MaxParticipants}</InfoItem>
                        <InfoItem label="Inschrijfdeadline">{companyVisitDetails.SoftSignUpDeadline}</InfoItem>
                        <InfoItem label="Aanmeldcode">{companyVisitDetails.SignUpCode}</InfoItem>
                        <InfoItem label="Aanmeldlink" colspan={2}>
                            <a
                                className="text-blue-600 underline break-all"
                                target="_blank"
                                href={SignUpTarget}
                                rel="noreferrer"
                            >
                                {SignUpTarget}
                            </a>
                        </InfoItem>
                    </InfoGrid>
                    <div className="mb-4 mt-4">
                        <DefaultButton content="Download deelnemersoverzicht" onClick={handleDownload}></DefaultButton>
                    </div>
                </SectionCard>

                <SectionCard title="Locatie">
                    <InfoGrid>
                        <InfoItem label="Adres">{companyVisitDetails.Address}</InfoItem>
                        <InfoItem label="Postcode">{companyVisitDetails.Zipcode}</InfoItem>
                        <InfoItem label="Plaats">{companyVisitDetails.City}</InfoItem>
                    </InfoGrid>
                </SectionCard>

                <SectionCard title="Cadeauservice">
                    <PresentServiceInfo
                        active={!!companyVisitDetails.PresentServiceActive}
                        category={companyVisitDetails.PresentCategory}
                    />
                </SectionCard>

                <SectionCard title="Ingeschreven kinderen">
                    {ownChildrenButton}
                    {dataTable}
                </SectionCard>
            </BoxLayout>
        )
    } else {
        dataViewer = (
            <BoxLayout>
                <div>Geen data voor dit bezoek in de database</div>
            </BoxLayout>
        )
    }
    return (
        <DefaultLayoutWithoutSideBar>
            {loading ? (
                <BoxLayout><div>Loading...</div></BoxLayout>

            ) : (
                <div className="flex flex-col overflow-auto py-4 sm:py-0">
                    {dataViewer}
                </div>
            )}
        </DefaultLayoutWithoutSideBar>
    )
}
export default ContactPersonVisitDetailPage